import Button from 'erxes-ui/lib/components/Button';

export default Button;
